import { logEvent } from "firebase/analytics";
import { analytics } from "../config/firebase";

/**
 * Fires a GA4 "signup_click" event when a user clicks any CTA that leads to the signup page.
 * @param language - current i18n language (e.g. "en", "es", "fr")
 * @param source   - where the click originated: "hero" | "cta_banner" | "navbar" | "pricing"
 */
export const trackSignupClick = (
  language: string,
  source: "hero" | "cta_banner" | "navbar" | "pricing",
): void => {
  if (!analytics) return;
  try {
    logEvent(analytics, "signup_click", { language, source });
  } catch {
    // Analytics unavailable — fail silently
  }
};

/**
 * Fires the standard GA4 "sign_up" event when an account is successfully created.
 * @param language - current i18n language (e.g. "en", "es", "fr")
 * @param method   - signup method: "email" | "google" | "apple"
 */
export const trackSignUp = (
  language: string,
  method: "email" | "google" | "apple" = "email",
): void => {
  if (!analytics) return;
  try {
    logEvent(analytics, "sign_up", { language, method });
  } catch {
    // Analytics unavailable — fail silently
  }
};

/**
 * Fires a GA4 "generate_lead" event when the contact form is successfully submitted.
 * Uses the standard GA4 recommended event name for lead/contact form submissions.
 * @param language - current i18n language (e.g. "en", "es", "fr")
 */
export const trackContact = (language: string): void => {
  if (!analytics) return;
  try {
    logEvent(analytics, "generate_lead", { language, source: "contact_form" });
  } catch {
    // Analytics unavailable — fail silently
  }
};
